{
  "home": {
    "listen": "listen to great music"
  }
}